
<section class="card-set-information" v-if="card.setInformation">
  <h4 class="secondary-font">Set Information</h4>

  <p v-html="card.setInformation" />
</section>
